import { AbstractControl, FormControl, ValidatorFn } from "@angular/forms";

export class AccountOptionsValidator{
  static debitCardApplicantType(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const formGroup = control as FormControl;
      const { 
        orderDebitCard, orderDebitCardForCoApplicant, orderDebitCardForPrimary, isJoint
      } = formGroup.value;
      
      if (orderDebitCard && isJoint) {
        if (!(orderDebitCardForCoApplicant | orderDebitCardForPrimary)) {
          return { 'orderDebitCardType': true }
        }
      }

      return null;
    }
  }
}